class CommonTaskModel {
    constructor({task_location = []} = {}) {
        this.taskLocation = task_location.map((location) => new TaskLocation(location));
    }

    static fromJson(json) {
        return new CommonTaskModel({
            task_location: json.task_location,
        });
    }

    toJson() {
        return {
            task_location: this.taskLocation.map((location) => location.toJson()),
        };
    }
}

class TaskLocation {
    constructor({
                    location_id = null,
                    task_id = null,
                    created_date = null,
                    updated_date = null,
                    address = null,
                    visit_time = null,
                    driver_name = null,
                    status = null,
                    updated_at = null,
                    vendor_name=null,
                    destination_hub_location_id = null,
                    destination_hub_location_name = null,
                    origin_hub_location_id = null,
                    origin_hub_location_name = null,
                    tasks_type = null,
                    client_location = null,
                    display_name = null,
                    task_age = null,
                } = {}) {
        this.locationId = location_id;
        this.taskId = task_id;
        this.createdDate = created_date;
        this.updatedDate = updated_date;
        this.address = address;
        this.visitTime = visit_time;
        this.driverName = driver_name;
        this.status = status;
        this.updatedAt = updated_at;
        this.vendorName=vendor_name||"-";
        this.destinationHubLocationId = destination_hub_location_id;
        this.destinationHubLocationName = destination_hub_location_name;
        this.originHubLocationId = origin_hub_location_id;
        this.originHubLocationName = origin_hub_location_name;
        this.tasksType = tasks_type ? new TasksType(tasks_type) : null;
        this.clientLocation = client_location;
        this.displayName = display_name;
        this.taskAge = task_age || null;
    }

    static fromJson(json) {
        return new TaskLocation(json);
    }

    toJson() {
        return {
            location_id: this.locationId,
            task_id: this.taskId,
            created_date: this.createdDate,
            updated_date: this.updatedDate,
            address: this.address,
            visit_time: this.visitTime,
            driver_name: this.driverName,
            status: this.status,
            updated_at: this.updatedAt,
            vendor_name:this.vendorName,
            destination_hub_location_id: this.destinationHubLocationId,
            destination_hub_location_name: this.destinationHubLocationName,
            origin_hub_location_id: this.originHubLocationId,
            origin_hub_location_name: this.originHubLocationName,
            tasks_type: this.tasksType ? this.tasksType.toJson() : null,
            client_location: this.clientLocation,
            display_name: this.displayName,
            task_age: this.taskAge
        };
    }
}

class TasksType {
    constructor({
                    task_id = null,
                    type = null,
                    code = null,
                    count = null,
                    concept = null,
                } = {}) {
        this.taskId = task_id;
        this.type = type;
        this.code = code;
        this.count = count;
        this.concept = concept;
    }

    static fromJson(json) {
        return new TasksType(json);
    }

    toJson() {
        return {
            task_id: this.taskId,
            type: this.type,
            code: this.code,
            count: this.count,
            concept: this.concept,
        };
    }
}

export {CommonTaskModel};